<template>
  <v-container>
    <v-form
      style="padding-left:0.5em"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-text-field v-model="title" label="Nombre del Proyecto" required />

      <v-textarea
        v-model="description"
        soloproject.
        name="input-7-4"
        label="Descripcion del Proyecto"
      />

      <v-row>
        <v-col cols="12">
          <v-combobox
            v-model="select"
            :items="itemsTags"
            label="Etiquetas"
            multiple
            chips
          ></v-combobox>
        </v-col>
      </v-row>

      <v-flex xs10>
        <v-text-field
          v-model="contributors"
          label="Añadir contribuidores"
          placeholder="user@gmail.com , user1@gmail.com"
        ></v-text-field>
      </v-flex>

      <v-switch
        v-model="visibility"
        :label="
          `Proyecto ${
            visibility
              ? 'privado (Sólo podrá visualizarlo usted)'
              : 'público (Podrá ser visualizado por cualquiera)'
          }`
        "
      ></v-switch>

      <v-btn
        :disabled="!valid"
        color="light-blue "
        class="mr-4"
        @click="validate()"
      >
        Crear Proyecto
      </v-btn>

      <v-btn color="error" class="mr-4" @click="reset">
        Resetear Formulario
      </v-btn>
    </v-form>

    <!--SnackBar for errors-->
    <v-snackbar v-model="snackbar" :right="true" :timeout="3000" :top="true">
      {{ message_snack }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { auth, firestore,} from "firebase";
import { mapActions } from "vuex";

export default {
  data: () => ({
    url_function:"https://us-central1-smartparcitipa-dev.cloudfunctions.net/send_mail",   //"http://localhost:5000/smartparcitipa-dev/us-central1/send_mail",
    id_new_project:"",
    contributors_correct: [],
    contributors_checked: undefined,
    snackbar: false,
    message_snack: "",
    valid: true,
    title: "",
    description: "",
    contributors: "",
    full_name: "",
    email: "",
    select: null,
    itemsTags: [
      "Salud",
      "Medicina",
      "Educación",
      "Investigación",
      "Tecnología",
      "Inteligencia Artificial"
    ],
    visibility: false,
    projectsUser: []
  }),

  beforeDestroy(){
    let contributors_list = this.contributors
      ? this.contributors.split(",")
      : [];
    this.contributors_checked = contributors_list;
    
    //Cargar info de los pendientes
    contributors_list.forEach( contributor => {
      //buscar informacion de contribuidores en base
      firestore()
        .collection("User")
        .where("email.primary", "==", contributor.trim())
        .get()
        // Si lo encuentra
        .then(snapshot => {
          let foundUser = false;

          snapshot.forEach(doc => {
            var data = doc.data();
            var user_name = "";
            if (data.first_name) {
              if (data.last_name)
                user_name = data.first_name + " " + data.last_name;
              else user_name = data.first_name;
            }
            this.contributors_correct.push({
              userId: doc.id,
              email: contributor.trim(),
              full_name: user_name
            });
            foundUser = true;
          });
          
          if (!foundUser)
            this.contributors_correct.push({
              email: contributor.trim(),
              full_name: ""
            });
          
          if (this.contributors_correct.length === this.contributors_checked.length){
            const filterObject = this.contributors_correct.filter(e => e.full_name.length > 1)
            filterObject.forEach((e) => this.addProjectField(e.userId));

            /* let correctData = this.contributors_correct.map(e => { return {
              email: e.email,
              full_name: e.full_name,
              }
            }); */
            this.sendData();
          }
        })
        // Si no lo encuentra
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error("Error buscando usuario: ", error);
        });
    });
  },
  methods: {
    ...mapActions("projects", ["createProject"]),

    addProjectField(userId) {
      firestore()
        .collection("User")
        .doc(userId)
        .get()
        .then(result => {
          const data = result.data();
          const obj = {
            id: this.id_new_project,
            name: this.title,
          }

          if (data.projectsPending) {
            data.projectsPending.push(obj);
          } else {
            data.projectsPending = [obj]
          }

          firestore()
            .collection("User")
            .doc(userId)
            .set(data, { merge: true })
            // eslint-disable-next-line no-console
            .then(() => console.log("Data del usuario guardada correctamente"))
            // eslint-disable-next-line no-console
            .catch((err) => console.error("Error al actualizar campos del usuario ", err));
        });
    },

    sendData() {
      firestore()
        .collection("Project")
        .doc(this.id_new_project)
        .set(
          {
            pendingContributors: this.contributors_correct
          },
          { merge: true }
        )
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Los pendientes fueron guardados");
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("No se guardo los nuevos contribuidores");
        });
    },

    validate() {
      this.send_mail();
      if (this.title !== "") {
        // Author User
        let currentU = auth().currentUser;
        if (currentU != null) {
          let currentUser = auth().currentUser.uid;
          // full_name
          firestore()
            .collection("User")
            .doc(currentUser)
            .onSnapshot(result => {
              var data = result.data();
              if (data.last_name)
                this.full_name = data.first_name + " " + data.last_name;
              else this.full_name = data.first_name;
              this.email = data.email.primary;

              
              const project = {
                description: this.description ? this.description : "",
                type: "",
                visibility: this.visibility ? "private" : "public",
                title: this.title,
                tags: this.select ? this.select : [],
                owner: { email: this.email, full_name: this.full_name },
                contributors: []
              };
              // eslint-disable-next-line no-console
              console.log("Proyecto: ", project);

              // Make the author contributor
              project.contributors.push({
                email: this.email,
                full_name: this.full_name
              });

              if (project) {
                firestore()
                  .collection("Project")
                  .add(project)
                  .then(docRef => {
                    this.id_new_project = docRef.id;
                    // eslint-disable-next-line no-console
                    console.log("Document written with ID: ", docRef.id);
                    this.message_snack = "Proyecto creado exitosamente";
                    this.send_mail();
                    this.snackbar = true;
                    this.$router.push({ name: "projects" });
                  })
                  .catch(error => {
                    // eslint-disable-next-line no-console
                    console.error("Error adding document: ", error);
                    this.message_snack = "Error al crear el proyecto";
                    this.snackbar = true;
                  });
              }
              
              // eslint-disable-next-line no-console
              // console.log("A");
            });
        }
      } else {
        this.message_snack = "No se pudo crear el proyecto";
        this.snackbar = true;
        this.reset();
      }
    },

    reset() {
      this.$refs.form.reset();
    },

    reviewEmail(email) {
      const numberSeparator = email.match(new RegExp("@", "g") || []);
      const numberFinalWord = email.match(new RegExp(".com", "g") || []);

      if (numberSeparator === null || numberSeparator.length != 1) {
        this.message_snack = "Ingreso de un mal formato de correos.";
        this.snackbar = true;
        this.reset();
      } else if (numberFinalWord === null || numberFinalWord.length != 1) {
        this.message_snack = "Mal formato de correo";
        this.snackbar = true;
        this.reset();
      } else {
        return true;
      }

      return false;
    },

    send_mail(){
      // eslint-disable-next-line no-unused-vars
      let validation = false;

      let correos = [];
      //let filterObj = [];
      let pos = this.contributors.indexOf(";");
      if (pos < 0) correos.push(this.contributors);
      else {
        correos = this.contributors.split(";");
        correos.forEach(mail => this.reviewEmail(mail));
      };

      correos.forEach(mail => {
        //if (filterObj.length != correos.length) return;
        // .where("email.primary", "==", mail.trim())
        firestore()
          .collection("User")
          .where("email.primary", "==", mail.trim())
          .get()
          .then(querySnapshot => {
            // eslint-disable-next-line no-unused-vars
            querySnapshot.forEach(doc => {
              validation = true;

              // envio de correo
              fetch(
                `${this.url_function}?data=${mail.trim()}-${validation}-${
                  this.title}`,{method:'GET',"Content-Type":"text/plain",mode:'no-cors'}
              )
                .then(Response => Response)
                .then(
                  // eslint-disable-next-line no-console
                  console.log(
                    "El correo ha sido enviado al usuario: ",
                    mail.trim()
                  )
                )
            });
            if (!validation) {
              // envio de emails
              fetch(
                `${this.url_function}?data=${mail.trim()}-${validation}-${
                  this.title
                }`,{method:'GET',"Content-Type":"text/plain",mode:'no-cors'}
              )
              .then(Response => Response)
              .then(
                // eslint-disable-next-line no-console
                  console.log(
                    "El correo ha sido enviado al mail: ",
                    mail.trim()
                  )
                )
            }
          })
      });
    }
  }
};
</script>
